
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-courses/[courseSlug]/advanced-quiz",
      function () {
        return require("private-next-pages/new-courses/[courseSlug]/advanced-quiz.tsx");
      }
    ]);
  